import { QUERY_ACTIVE_WORKSPACE_V2 } from '@/graphql/query.graphql';
import { ActiveWorkspacesV2Query, ActiveWorkspacesV2QueryVariables } from '@/types/generated/graphql';
import { useCursorPagination } from '@shared/hooks/use-cursor-pagination';
import { useState, useEffect } from 'react';

export function useActiveWorkspaces() {
  const [filter, setFilter] = useState({
    query: '',
    limit: 15,
  });
  const [currentWorkspaceCount, setCurrentWorkspaceCount] = useState(0);
  function handleClearFilter() {
    setFilter((prev) => ({ ...prev, query: '' }));
  }
  const { data, initialLoading, hasNextPage, loadNextRef, loading } = useCursorPagination<
    ActiveWorkspacesV2Query,
    ActiveWorkspacesV2QueryVariables
  >({
    schema: QUERY_ACTIVE_WORKSPACE_V2,
    responseDataKey: 'activeWorkspacesV2',
    variables: filter,
  });

  useEffect(() => {
    const currentWorkspace = data?.data?.find((workspace) => workspace?.isCurrent);
    if (currentWorkspace?.unreadCountWorkspace !== undefined) {
      setCurrentWorkspaceCount(Number(currentWorkspace.unreadCountWorkspace));
    }
  }, [data]);
  return {
    data,
    setFilter,
    loadNextRef,
    filter,
    loading,
    hasNextPage,
    initialLoading,
    handleClearFilter,
    currentWorkspaceCount,
    setCurrentWorkspaceCount,
  };
}
